module.exports = __webpack_public_path__ + "img/img_紅包bg@2x.008ad32e.png";